import http from "../http-common";
import authHeader from "../../services/auth-header";

const record = (data) => {
  return http.post("/loan-application-fees", data, { headers: authHeader() });
};

const getAll = (params) => {
  return http.get("/loan-application-fees", { headers: authHeader(), params });
};

const getMemberFees = (memberId) => {
  return http.get(`/loan-application-fees/member/${memberId}`, { headers: authHeader() });
};

const LoanApplicationFeeService = {
  record,
  getAll,
  getMemberFees
};

export default LoanApplicationFeeService;
